import { alpha, Box, Typography, useTheme } from "@mui/material";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";

export const NoEmptyPdfCore = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "50vh",
        gap: 2,
      }}
    >
      <Box
        sx={{
          width: 64,
          height: 64,
          borderRadius: "16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: alpha(theme.palette.primary.main, 0.08),
        }}
      >
        <FilterAltOutlinedIcon
          sx={{ fontSize: 28, color: theme.palette.primary.main }}
        />
      </Box>

      <Typography variant="subtitle1" fontWeight={600} color="text.primary">
        Nenhum relatório gerado
      </Typography>

      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ maxWidth: 280, textAlign: "center", lineHeight: 1.6 }}
      >
        Clique em <strong>Filtro</strong> para configurar os parâmetros e gerar
        o relatório.
      </Typography>
    </Box>
  );
};
